var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNovaLogo2 = function SvgNovaLogo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1FF66",
    d: "M4.808.775H0V5.07h4.808z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M.002 16.521h4.806V5.066L.002 9.874zM16.955 3.557c-.173-.687-.461-1.24-.854-1.641-.394-.401-.924-.693-1.581-.866-.693-.181-1.575-.275-2.623-.275H9.104L4.811 5.07h4.035c.66 0 1.204.033 1.614.096.461.072.84.234 1.127.481q.443.385.588 1.067c.085.398.13.929.13 1.575v8.236h4.925V6.262c0-1.072-.093-1.982-.275-2.702z"
  })));
};
export default SvgNovaLogo2;